import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFArrowRightForAni } from '@/components/UI/svg/ProductStatic';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/deltamax/pc/');

export default function Comp() {
    const { useLang, useRouter, Link } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('delta_max_static');
    const imgMap: any = {
        au: 'au',
        uk: 'uk',
        de: 'eu',
        fr: 'eu',
        us: 'us',
        cn: 'cn',
        es: 'eu',
        ru: 'eu',
        cis: 'eu',
        it: 'eu',
        sa: 'uk',
    };
    const isShowLink = ['us', 'ca', 'au', 'uk', 'za', 'eu'].includes(locale);

    const imgUrlFront = `dualcharging/${imgMap[locale] || imgMap.us}`;

    const isAr = locale == 'sa';
    const getFinalUnit = (baseUnit: string, arabUnit: string) => {
        return isAr ? arabUnit : baseUnit;
    };

    return (
        <div className={`${css.gsapdGroupC} gsapdGroupC`}>
            <div className="gsapdGroupC-in">
                <div className="c-box-l">
                    <div className="c-box-l-item c-box-l-a">
                        <div className="c-box-inter">
                            <div className="msg-logo">
                                <EFPic name={['invalid-name.webp', 'invalid-name.png']} className="fullImgs" />
                            </div>
                            {['jp'].includes(locale) ? (
                                <div className="msg-box-a-1">
                                    {t('Fast')} {t('charging_letter')}
                                </div>
                            ) : (
                                <div className="msg-box-a-1">
                                    {t('Fast')} <br />
                                    {t('charging_letter')}
                                </div>
                            )}
                            <div className="msg-box-b">{t('FC_desc')}</div>
                            {isShowLink && (
                                <Link href="/x-stream" className="stream-link" newWin>
                                    <div className="link">
                                        <span>{t('x_stream_link')}</span>
                                        <EFArrowRightForAni />
                                    </div>
                                </Link>
                            )}
                            <div className="msg-box-a">
                                <div className="msg-a-li">
                                    <div className="msg-a-line1">{t('Input')}</div>
                                    <div className="msg-a-line2">{t('FC_1800')}</div>
                                </div>
                                <div className="msg-a-li">
                                    <div className="msg-a-line1">{t('Full Charge')}</div>
                                    <div className="msg-a-line2">
                                        {t('FC_charge_time')} <span className="msg-a-small">{getFinalUnit(t('Hrs'), t('Hrs4'))}</span>{' '}
                                    </div>
                                </div>
                            </div>
                            <div className="msg-box4">
                                {t('FC_input_pc1')}
                                <br />
                                {t('FC_input_pc2')}
                            </div>
                        </div>
                    </div>
                    <div className="c-box-l-item c-box-l-b">
                        <div className="c-box-inter">
                            <div className="msg-box-b-1">{t('fast_dual_charging')}</div>
                            {t.rich('TPS_pc', {
                                line1: (child) => <div className="msg-box-b-2">{child}</div>,
                                line2: (child) => <div className="msg-box-b-3">{child}</div>,
                            })}
                            <div className="msg-box-b">
                                <div className="msg-box-b-line1">{t('TPS_desc')}</div>
                                <div className="msg-box-b-line2">{t('TPS_desc1')}</div>
                            </div>
                            <div className="msg-box-a">
                                <div className="msg-a-li">
                                    <div className="msg-a-line1">{t('Input')}</div>
                                    <div className="msg-a-line2">{t('TPS_AC_input')}</div>
                                </div>
                                <div className="msg-a-li">
                                    <div className="msg-a-line1">{t('Full Charge')}</div>
                                    <div className="msg-a-line2">
                                        {t('TPS_AC_charge')} <span className="msg-a-small">{getFinalUnit(t('Hrs'), t('Hrs4'))}</span>{' '}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="c-box-l-item c-box-l-c">
                        <div className="c-box-inter">
                            <div className="msg-box-b-1">{t('fast_dual_charging')}</div>
                            <div className="msg-box-c-2">
                                {t('STDC_pc1')} <br /> {t('STDC_pc2')}
                            </div>
                            <div className="msg-box-c-3">{t('STDC_pc3')}</div>
                            <div className="msg-box-b">{t('STDC_desc')}</div>
                            <div className="msg-box-a">
                                <div className="msg-a-li">
                                    <div className="msg-a-line1">{t('Input')}</div>
                                    <div className="msg-a-line2">{t('STDC_input')}</div>
                                </div>
                                <div className="msg-a-li">
                                    <div className="msg-a-line1">{t('Full Charge')}</div>
                                    <div className="msg-a-line2">
                                        {t('STDC_charge')} <span className="msg-a-small">{getFinalUnit(t('Hrs'), t('Hrs4'))}</span>{' '}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="c-box-r">
                    <div className="dulta-bg dulta-bg-theme">
                        <EFPic name={[`${imgUrlFront}/theme01.webp`, `${imgUrlFront}/theme01.png`]} className="fullImgs" alt={''} />
                    </div>
                    <div className="status-bg status-bg-1">
                        <EFPic name={[`${imgUrlFront}/status1.webp`, `${imgUrlFront}/status1.png`]} className="fullImgs" alt={''} />
                    </div>
                    <div className="status-bg status-bg-2">
                        <EFPic name={[`${imgUrlFront}/status2.webp`, `${imgUrlFront}/status2.png`]} className="fullImgs" alt={''} />
                    </div>
                    <div className="status-bg status-bg-3">
                        <EFPic name={[`${imgUrlFront}/status3.webp`, `${imgUrlFront}/status3.png`]} className="fullImgs" alt={''} />
                    </div>
                    <div className="status-bg status-bg-4">
                        <EFPic name={[`${imgUrlFront}/status4.webp`, `${imgUrlFront}/status4.png`]} className="fullImgs" alt={''} />
                    </div>
                    <div className="gsapdGroupc-canvas2" id="gsapdGroupc-canvas2"></div>
                </div>
            </div>
        </div>
    );
}
